import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSEO, useJsonLd } from '@/lib/useSEO';
import { MARKETING_SEO, MARKETING_JSON_LD, SITE_URL } from './seo';
import { MarketingNav } from './MarketingNav';
import { MarketingFooter } from './MarketingFooter';
import { FONT_B } from './theme';

export function MarketingLayout({ children, testId, navOverDark = false }) {
  const { pathname } = useLocation();
  const seo = MARKETING_SEO[pathname];

  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  useSEO({
    title: seo?.title,
    description: seo?.description,
    image: seo?.image ? `${SITE_URL}${seo.image}` : undefined,
    url: `${SITE_URL}${pathname === '/' ? '/' : pathname}`,
  });
  useJsonLd(MARKETING_JSON_LD[pathname]);

  return (
    <div className="public-light-theme bg-white text-gray-900" style={FONT_B} data-testid={testId}>
      <MarketingNav overDark={navOverDark} />
      <main>{children}</main>
      <MarketingFooter />
    </div>
  );
}
